export default "__VITE_ASSET__Cexugrj6__"